const DashboardSkeleton = () => {
  return (
    <div className="space-y-8 animate-pulse">
      {[1, 2, 3].map((section) => (
        <div
          key={section}
          className="bg-white rounded-3xl p-5 shadow-sm"
        >
          {/* Header Skeleton */}
          <div className="flex items-center gap-3 border-b-2 border-gray-100 pb-3 mb-5">
            <div className="w-10 h-10 rounded-xl bg-gray-200"></div>

            <div className="space-y-2">
              <div className="h-5 w-44 bg-gray-200 rounded"></div>
              <div className="h-3 w-24 bg-gray-100 rounded"></div>
            </div>
          </div>

          {/* Cards Skeleton */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[1, 2, 3, 4].map((card) => (
              <div
                key={card}
                className="border border-gray-100 rounded-2xl p-5 bg-white h-44"
              >
                <div className="h-4 w-28 bg-gray-200 rounded"></div>

                <div className="flex flex-col items-center justify-center mt-8">
                  <div className="h-10 w-24 bg-gray-200 rounded-lg"></div>

                  <div className="h-3 w-20 bg-gray-100 rounded mt-5"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardSkeleton;